<div class="flex flex-column mb-1">
  <ng-container *ngIf="files$ | async; let files">
    <ng-container *ngIf="!files.length">
      {{emptyPlaceholder}}
    </ng-container>
    <!-- Archivos que ya existen bien en la DB   -->
    <lib-file-item  *ngFor="let fileItem of files; index as i"
      [file]="fileItem"
      [canEdit]="canEdit"
      [canDelete]="canDelete"
      [canView]="canView"
      (action)="onAction($event, i, fileItem)">
    </lib-file-item>
  </ng-container>

  <!-- Archivos que están cargando -->
  <ng-container *ngFor="let uploadFile of uploadFiles; index as i">
    <lib-file-upload
      [file2Upload]="uploadFile"
      [collection] = "collection"
      [path]="path"
      [ref]="ref"
      (state)="onUploadFileState($event, uploadFile)"
    ></lib-file-upload>
  </ng-container>
</div>

<p-fileUpload *ngIf="canUpload" #uploadButton styleClass="transparent-upload" mode="basic" chooseIcon="pi pi-paperclip"  chooseLabel="Subir archivos"
  [multiple]="true"
  [auto]="true"
  [maxFileSize]="maxFileSize"
  [fileLimit]="maxFiles"
  [customUpload]="true" (uploadHandler)="onUploadAuto($event)"
></p-fileUpload>
